import type { ChangeEvent } from 'react';
import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDebounce } from 'react-use';
import { useRecoilState } from 'recoil';

import { SearchInput } from '../../../../../../shared/ui';
import { incidentsFilterState } from '../../../../../../state/incidentsFilter';

const SEARCH_DEBOUNCE = 500;

export const SearchInputPanel = () => {
  const [filterState, setFilterState] = useRecoilState(incidentsFilterState);
  const [searchText, setSearchText] = useState(filterState.text);
  const { t } = useTranslation();

  useDebounce(
    () => {
      setFilterState((state) => ({ ...state, text: searchText }));
    },
    SEARCH_DEBOUNCE,
    [setFilterState, searchText],
  );

  const changeHandler = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSearchText(event.target.value);
  };

  return <SearchInput value={searchText} onChange={changeHandler} placeholder={t('search')} />;
};
